export default __webpack_public_path__ + "static/media/fundoapp.c9814ccf.png";